<template>
	<div>
		<div class="row mb-2">
			<div class="col-sm-12 col-md-6 col-lg-5 col-xl-3" v-if="form">

				<div class="form-group">
					<label>Название</label>
					<div class="input-group">
						<input type="text" class="form-control" v-model="form.title">
						<div class="input-group-append">
							<button class="btn btn-outline-secondary" title="отправить название в ссылку" type="button"
								@click="form.url = form.title">
								<i class="uil-angle-double-down"></i>
							</button>
						</div>
					</div>
				</div>

				<div class="form-group">
					<label>Ссылка <small>(читаемая ссылка на страницу)</small></label>
					<input type="text" v-model="form.url" class="form-control">
					<input type="text" v-model="form.url_slug" disabled class="form-control">
				</div>

				<div class="form-group">
					<label for="item_name">Показывать на сайте</label><br>

					<input type="checkbox" id="switch_show" v-model="form.show" data-switch="success" />
					<label for="switch_show" data-on-label="Да" data-off-label="Нет"></label>
				</div>

				<div v-if="!loading">
					<button v-if="form.mode == 'add'" type="button" class="btn btn-primary"
						@click.prevent="addItem()">Создать</button>
					<button v-if="form.mode == 'edit'" type="button" class="btn btn-primary"
						@click.prevent="editItem()">Сохранить</button>
				</div>
				<button v-else class="btn btn-primary" type="button" disabled>
					<span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
					Отправка данных...
				</button>
			</div>
		</div>

		<div class="row" v-if="items == null">
			<div class="col-md-12 text-center">
				<div class="spinner-grow" role="status">
					<span class="sr-only">Loading...</span>
				</div>
			</div>
		</div>

		<div class="row" v-else>
			<table class="table table-striped table-centered  table-responsive-md mb-0">
				<thead>
					<tr>
						<th>ID</th>
						<th>Название</th>
						<th>Ссылка</th>
						<th>Показан</th>
						<th>Удален</th>
						<th>Дата создания</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, i) in filteredItems" :key="i">
						<td>{{ item._id }}</td>
						<td>{{ item.title }}</td>
						<td>{{ item.url_slug }}</td>
						<td>
							<div class="badge" :class="item.show ? 'badge-success' : 'badge-secondary'">
								<span v-if="item.show">Показан на сайте</span>
								<span v-else>Скрыт</span>
							</div>
						</td>
						<td>
							<div class="badge" :class="item.deleted ? 'badge-danger' : 'badge-secondary'">
								<span v-if="item.deleted">Удален</span>
								<span v-else>Нет</span>
							</div>
						</td>
						<td>{{ formatDate(item.createdAt) }}</td>
						<td>
							<button class="btn btn-sm btn-rounded btn-secondary"
								@click="moveItemToEdit(item)">редактировать</button>

							<button v-if="item.deleted" class="btn btn-sm btn-rounded btn-warning ml-1"
								@click="restoreItem(item._id)">восстановить</button>
							<button v-else class="btn btn-sm btn-rounded btn-danger ml-1"
								@click="deleteItem(item._id)">удалить</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

	</div>
</template>

<script>
import { mapState } from 'vuex'
import log from '@/plugins/log'
import { to } from '@/plugins/utils'
import * as dayjs from 'dayjs'

import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/ru'

dayjs.extend(localizedFormat)
dayjs.locale('ru')

export default {
	name: 'BlogCategoryList',
	data: () => {
		return {
			defaultForm: {
				mode: 'add',
				_id: null,
				title: '',
				url: '',
				url_slug: '',
				show: false
			},
			form: null,
			items: null,
			loading: false,
			filter: {
				deleted: false
			}
		}
	},
	computed: {
		filteredItems() {
			return this.items.filter(item => {
				//if(this.filter.deleted === false && item.deleted) return false
				return true
			})
		}
	},
	beforeMount() {
		this.resetForm()
		this.getData()
	},
	mounted() {
		log.debug('/views/shop_set_collection/list', 'mounted')
	},
	watch: {
		'form.url': function (newVal, oldVal) {
			this.form.url_slug = cyr2lat(newVal).toLocaleLowerCase()
		}
	},
	methods: {
		async getData() {
			var [err, response] = await to(this.$http.get('/shop_set_collection/list'))
			if (err) {
				log.error('/views/shop_set_collection/list', 'methods.getData', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			log.debug('/views/shop_set_collection/list', 'methods.getData', '$http.request', response.data)

			this.items = response.data.items
		},

		async addItem() {
			if (!this.form.title) return $.NotificationApp.send("Ошибка", "Введите название", "top-right", "", "error")
			this.loading = true

			var [err, response] = await to(this.$http.post('/shop_set_collection/add', this.form))
			if (err) {
				this.loading = false
				log.error('/views/shop_set_collection/add', 'methods.addItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if (!response.data.success) {
				this.loading = false
				log.error('/views/shop_set_collection/add', 'methods.addItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			this.loading = false
			log.debug('/views/shop_set_collection/add', 'methods.addItem', '$http.request', response.data)

			this.getData()
			this.resetForm()
		},

		async editItem() {
			this.loading = true
			var [err, response] = await to(this.$http.post(`/shop_set_collection/edit/${this.form._id}`, this.form))
			if (err) {
				this.loading = false
				log.error(`/views/shop_set_collection/edit/${this.form._id}`, 'methods.editItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if (!response.data.success) {
				this.loading = false
				log.error(`/views/shop_set_collection/edit/${this.form._id}`, 'methods.editItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			this.loading = false
			log.debug(`/views/shop_set_collection/edit/${this.form._id}`, 'methods.editItem', '$http.request', response.data)
			$.NotificationApp.send("Успешно", '', "top-right", "", "success")


			this.getData()
			this.resetForm()
		},


		async deleteItem(id) {
			if (!confirm('Уверены, что хотите удалить?')) return;

			var [err, response] = await to(this.$http.post(`/shop_set_collection/delete/${id}`))
			if (err) {
				log.error('/views/shop_set_collection/list', 'methods.deleteItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			if (!response.data.success) {
				log.error('/views/shop_set_collection/list', 'methods.deleteItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/shop_set_collection/list', 'methods.deleteItem', '$http.request', response.data)

			this.getData()
		},
		async restoreItem(id) {
			var [err, response] = await to(this.$http.post(`/shop_set_collection/restore/${id}`))
			if (err) {
				log.error('/views/shop_set_collection/list', 'methods.restoreItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			if (!response.data.success) {
				log.error('/views/shop_set_collection/list', 'methods.restoreItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/shop_set_collection/list', 'methods.restoreItem', '$http.request', response.data)

			this.getData()
		},

		moveItemToEdit(item) {
			this.resetForm()

			this.form = Object.assign({}, this.form, item)
			this.form.mode = 'edit'
		},

		formatDate(date) {
			return dayjs(date).format('LL')
		},
		resetForm() {
			this.form = Object.assign({}, this.defaultForm)
		}
	}
};

function cyr2lat(str) {
	var cyr2latChars = new Array(['а', 'a'], ['б', 'b'], ['в', 'v'], ['г', 'g'], ['д', 'd'], ['е', 'e'], ['ё', 'yo'], ['ж', 'zh'], ['з', 'z'], ['и', 'i'], ['й', 'y'], ['к', 'k'], ['л', 'l'], ['м', 'm'], ['н', 'n'], ['о', 'o'], ['п', 'p'], ['р', 'r'], ['с', 's'], ['т', 't'], ['у', 'u'], ['ф', 'f'], ['х', 'h'], ['ц', 'c'], ['ч', 'ch'], ['ш', 'sh'], ['щ', 'shch'], ['ъ', ''], ['ы', 'y'], ['ь', ''], ['э', 'e'], ['ю', 'yu'], ['я', 'ya'], ['А', 'A'], ['Б', 'B'], ['В', 'V'], ['Г', 'G'], ['Д', 'D'], ['Е', 'E'], ['Ё', 'YO'], ['Ж', 'ZH'], ['З', 'Z'], ['И', 'I'], ['Й', 'Y'], ['К', 'K'], ['Л', 'L'], ['М', 'M'], ['Н', 'N'], ['О', 'O'], ['П', 'P'], ['Р', 'R'], ['С', 'S'], ['Т', 'T'], ['У', 'U'], ['Ф', 'F'], ['Х', 'H'], ['Ц', 'C'], ['Ч', 'CH'], ['Ш', 'SH'], ['Щ', 'SHCH'], ['Ъ', ''], ['Ы', 'Y'], ['Ь', ''], ['Э', 'E'], ['Ю', 'YU'], ['Я', 'YA'], ['a', 'a'], ['b', 'b'], ['c', 'c'], ['d', 'd'], ['e', 'e'], ['f', 'f'], ['g', 'g'], ['h', 'h'], ['i', 'i'], ['j', 'j'], ['k', 'k'], ['l', 'l'], ['m', 'm'], ['n', 'n'], ['o', 'o'], ['p', 'p'], ['q', 'q'], ['r', 'r'], ['s', 's'], ['t', 't'], ['u', 'u'], ['v', 'v'], ['w', 'w'], ['x', 'x'], ['y', 'y'], ['z', 'z'], ['A', 'A'], ['B', 'B'], ['C', 'C'], ['D', 'D'], ['E', 'E'], ['F', 'F'], ['G', 'G'], ['H', 'H'], ['I', 'I'], ['J', 'J'], ['K', 'K'], ['L', 'L'], ['M', 'M'], ['N', 'N'], ['O', 'O'], ['P', 'P'], ['Q', 'Q'], ['R', 'R'], ['S', 'S'], ['T', 'T'], ['U', 'U'], ['V', 'V'], ['W', 'W'], ['X', 'X'], ['Y', 'Y'], ['Z', 'Z'], [' ', '-'], ['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['-', '-']);

	var newStr = new String();

	for (var i = 0; i < str.length; i++) {

		var ch = str.charAt(i);
		var newCh = '';
		for (var j = 0; j < cyr2latChars.length; j++) {
			if (ch == cyr2latChars[j][0]) {
				newCh = cyr2latChars[j][1];
			}
		}
		newStr += newCh;
	}
	return newStr.replace(/[-]{2,}/gim, '-').replace(/\n/gim, '');
}
</script>